<section class="carousel-slide-chart" data-testid="htc-slide-chart">
  @if (data.title) {
    <p
      *htcReadAloud="
        {
          id: 'activity-title',
          text: data.title | htcMathToSpeech: (sres.lastAddedMapKey | async)
        };
        type: 'NO_PAUSE';
        theme: 'LIGHT'
      "
      data-testid="title">
      <htc-math-text-wrapper
        [attr.aria-label]="
          data.title | htcMathToSpeech: (sres.lastAddedMapKey | async)
        "
        [textInput]="data.title"></htc-math-text-wrapper>
    </p>
  }

  <section class="chart-wrapper">
    <htc-expandable-wrapper
      [chart]="{
        title: data.chartData?.title ?? '',
        data: data.chartData?.data ?? '' | cdnSrcBaseUrl,
        isUrl: data.chartData?.isUrl ?? false
      }"
      [isContentLoaded]="contentLoaded">
      <htc-chart
        [chartTitle]="data.chartData?.title ?? ''"
        [data]="data.chartData?.data ?? '' | cdnSrcBaseUrl"
        [isDataUrl]="data.chartData?.isUrl ?? false"
        [fitToParentElement]="false"
        (chartLoaded)="onLoadComplete()"></htc-chart>
    </htc-expandable-wrapper>
    <ngx-skeleton-loader
      [hidden]="contentLoaded"
      appearance="circle"
      [count]="1"
      animation="pulse"
      [theme]="{
        width: '100%',
        height: '5rem',
        'border-radius': '0.3125rem',
        margin: 0
      }"></ngx-skeleton-loader>
  </section>
</section>
